package com.milta.core.localization.translations.it

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Annulla",
    confirm = "Conferma",
    save = "Salva",
    delete = "Elimina",
    back = "Indietro",
    loading = "Caricamento…",
    retry = "Riprova",
    creationInProgressDoNotClose = "Creazione in corso, non chiudere la finestra",
    processingStepSent = "Documento inviato",
    processingStepReading = "Lettura del documento",
    processingStepFinding = "Ricerca delle consegne",
    processingStepChecking = "Verifica degli indirizzi",
    processingUsualDuration = "Di solito da 20 a 40 secondi. Resti su questa schermata, al resto pensiamo noi.",
    processingLongWait = "Il documento contiene molte informazioni, l'analisi richiede un po' più del solito. Tutto funziona, stiamo continuando.",
    processingInProgressSince = "In corso da %1",
    processingFinishedIn = "Terminata in %1",
    processingDeliveriesFound = "%1 consegne trovate",
    processingDeliveriesFoundOne = "1 consegna trovata",
    processingAddressesChecked = "%1 di %2 indirizzi",
    addressVerifiedBadge = "✓ Indirizzo verificato",
    addressNeedsReviewBadge = "⚠ Indirizzo da verificare",
    addressFoundLine = "Trovato: %1",
    language = "Lingua",
    welcomeTitle = "Benvenuto su Milta",
    welcomeSubtitle = "Il tuo assistente intelligente per le consegne",
    alreadyHaveAccount = "Ho già un account",
    createAccount = "Crea un account",
    continueWithGoogle = "Continua con Google",
    continueWithApple = "Continua con Apple",
    oauthErrorGeneric = "Si è verificato un errore durante l'accesso. Riprova.",
    oauthAppleWebComingSoon = "L'accesso con Apple sarà presto disponibile sul web.",
    oauthDriverAccountNotAllowedOnWeb = "Gli account autista non possono accedere alla dashboard web. Accedi tramite l'app mobile.",
    oauthAccountNotFoundOnWeb = "Nessun account Milta trovato per questo account Google.",
    errorOffline = "Nessuna connessione internet.",
    navTourneesDuJour = "Giri di oggi",
    navAjouterUneTournee = "Aggiungi un giro",
    navHistoriqueDesPreuves = "Storico consegne",
    navParametres = "Impostazioni",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "Nessuna consegna",
    noDeliveriesYetSubtitle = "Tocca «Aggiungi consegne» per aggiungerne",
    optimizationUnavailableExplanation = "Vuoi creare il giro senza ottimizzazione, oppure riprovare?",
    createWithoutOptimizationAction = "Crea senza ottimizzazione",
    gpsAppSheetTitle = "Scegli un'app di navigazione",
    addressSearchingLabel = "Ricerca in corso…",
    clearTimeFieldAction = "Cancella",
    clearTimeFieldConfirmTitle = "Cancellare l'orario?",
    clearTimeFieldConfirmMessage = "L'orario attuale verrà rimosso. Potrai impostarne uno nuovo in qualsiasi momento.",
    updateRequiredTitle = "Aggiornamento obbligatorio",
    updateRequiredMessage = "È disponibile una nuova versione di Milta. Aggiorna l'app per continuare a usarla.",
    updateInstalledVersionLabel = "Installata",
    updateAvailableVersionLabel = "Disponibile",
    updateNowButton = "Aggiorna",
    updateDataKeptNote = "I tuoi giri e le tue consegne vengono conservati.",
    updateSendingPendingOne = "Invio di 1 consegna convalidata offline…",
    updateSendingPendingMany = "Invio di {count} consegne convalidate offline…",
)
